import { ReactNode } from 'react';
import { OverviewActionFunction } from '../ObjectList/type';
import { TableActionFunction } from '../Table4/types';
import { TableActionProps } from './type';

export type Overview = TableActionProps & {
  assetId: number;
  isTracked: boolean;
};

interface Return {
  enabled: boolean;
  label: string;
  icon: ReactNode;
}

export type OverviewReturn = Return & {
  function?: OverviewActionFunction;
};

export type TableReturn = Return & {
  function?: TableActionFunction;
};

export function isOverview(props: unknown): props is Overview {
  return Boolean((props as Overview).assetId);
}
